module.exports = "/_next/static/images/7f0dbf2f23304e855562fd309d513350-blog-075x.jpg";